import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseComponent } from '../../Library/BaseComponent';
import { MasterDataService } from '../../Services/MasterDataService';
import { NgbModal, NgbActiveModal, NgbModalRef, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { StaffBasicInfo } from '../../Models/GlobalEntities';
import { EntityCodes } from '../../Models/EnumModels';
import { UserService } from '../../Services/UserService';
import * as _ from 'lodash';
import { OpenJobsInformation } from '../OpenJobsInformation/OpenJobsInformation';
import { ShiftSetUpService } from '../../Services/ShiftSetUpService';
import { LoginLogoutRequest } from '../../Models/RequestModels';

@Component({
    selector: 'ShiftDetail',
    templateUrl: './ShiftDetail.html',
})

export class ShiftDetail extends BaseComponent implements OnInit {
    @ViewChild('content') content;
    @ViewChild('openJobsInformation') OpenJobsInformation: OpenJobsInformation;
    ModalRef: NgbModalRef;
    Model: Array<any>;
    StaffId: number;
    StaffName: string;
    DisableModalOpenEvent: boolean = false;
    AllPropertySelected: boolean = false;
    SelectedPropertiesLst: any;
    LoginLogoutRequestLst: Array<LoginLogoutRequest>;
    HasMNTLicense : boolean = false;
    constructor(public translate: TranslateService, public toastr: ToastrService, public route: ActivatedRoute, public router: Router, public masterService: MasterDataService, public modalService: NgbModal, public userService: UserService, public shiftSetUpService: ShiftSetUpService,) {
        super(translate, toastr, route, router, masterService);

    }
    ngOnInit(): void {
    }

    Open(): void {
        if (this.DisableModalOpenEvent) return;
        this.Model = [];
        this.SelectedPropertiesLst = [];
        this.LoginLogoutRequestLst = [];
        this.AllPropertySelected = false;
        this.StaffId = this.masterService.LoggedInUserData.StaffId;
        this.StaffName = this.masterService.LoggedInUserData.FName + ' ' + this.masterService.LoggedInUserData.LName; 
        let ngbModalOptions: NgbModalOptions = {
            backdrop : 'static',
            size: 'lg', 
            centered: true
        };
        this.ModalRef = this.modalService.open(this.content, ngbModalOptions);
        this.DisableModalOpenEvent = true;
        this.GetData();
        this.ModalRef.result.then((result) => {
        }, (reason) => {
            this.DisableModalOpenEvent = false;
        });
    }

    GetData(): void {
        this.userService.Staff_GetShiftDetails(this.StaffId).then(async data => {
            if (data && !data.HasError) {
                let woData;
                if(this.masterService.CheckActiveLicence_Module(this.masterService.ActivePropertyID, 'KMT_CORE')){
                    // Get MNT WO Data Data
                    this.HasMNTLicense = true;
                    woData = await this.userService.GetOpenWOs()
                }
                this.Model = _.cloneDeep(data.Result.ListShiftDetails);
                this.Model.forEach(obj => {
                    obj.Selected = false;
                    obj.StaffId = this.StaffId;
                    obj.Description = this.StaffName;
                    let Sections = data.Result.ListStaffSections.filter(item => item.PropertyId == obj.PropertyId);
                    obj.SectionsName = this.GetSectionName(Sections);
                    if(woData && woData.Result){
                        let foundResult = woData.Result.find((wo) => wo.PropertyId === obj.PropertyId);
                        obj.WorkOrders = foundResult && foundResult.Count ? foundResult.Count : 0
                    }
                })  
            }

        })
    }

    GetSectionName(SectionList: any): string {
        let arrlen = SectionList.length;
        if (arrlen > 0) {
            let SectionName = "";
            for (let i = 0; i < arrlen; i++) {
                SectionName += this.masterService.MasterData_GetMutli(SectionList[i].PropertyId, SectionList[i].SectionId, EntityCodes.Sections, "");
                if (i < (arrlen - 1)) {
                    SectionName += ', ';
                }
            }
            SectionName = SectionName.replace(/,$/, '');
            return SectionName;
        }

        return ;
    }

    UpdateStaffData(data: any) {
        this.GetData();
    }

    SelectProperty(row, event) {
        let count: number = 0;
        if (event.target.checked) {
            //let i = this.Model.findIndex(obj => obj.PropertyCode == row.PropertyCode);
            row.Selected = true;
            this.SelectedPropertiesLst.push(row.PropertyId);
        }
        else {
            this.Model.find(obj => obj.PropertyCode == row.PropertyCode).Selected = false;
            let i = this.SelectedPropertiesLst.findIndex(a => a == row.PropertyId);
            if (i >= 0) {
                this.SelectedPropertiesLst.splice(i, 1);
            }
        }
        this.Model.forEach(obj => {            
            if (obj.Selected)
                count++;
        })
        if (count == this.Model.length)
            this.AllPropertySelected = true;
        else
            this.AllPropertySelected = false;
    }

    SelectAllProperty(event) {
        if (event.target.checked) {
            this.Model.forEach(obj => {
                obj.Selected = true;
                this.SelectedPropertiesLst.push(obj.PropertyId);
            })
        }
        else {
            this.Model.forEach(obj => {
                obj.Selected = false;
            })
            this.SelectedPropertiesLst = [];
        }
    }

    StartShift() {
        let req = this.SetRequestObj(true);
        this.Model.forEach(a => {
            if (a.Selected)
                req.Properties.push(a.PropertyId);
        })
        this.LoginLogoutRequestLst.push(req);
        this.shiftSetUpService.LoginLogout(this.LoginLogoutRequestLst).then(data => {
            if (data.HasError) {
                this.GetMultilingualToast(data.Errors[0].ErrorMessage, 'error');
            }
            if (data && data.Result) {
                this.GetMultilingualToast('TS.TS_SHIFT_START_SUCCESS', 'success');
               this.ModalRef.close();
            }
        })
    }

    EndShift() {
        let req = this.SetRequestObj(false);
       let SelectedPropertiesList = [];
        this.Model.forEach(a => {
            if (a.Selected)
                req.Properties.push(a.PropertyId);
            if (a.Selected && (a.GuestCalls > 0 || a.StaffCalls > 0))
                SelectedPropertiesList.push(a.PropertyId);
        })
        if (SelectedPropertiesList.length > 0)
            this.OpenJobsInformation.Open(SelectedPropertiesList);
        else {
            this.LoginLogoutRequestLst.push(req);
            this.shiftSetUpService.LoginLogout(this.LoginLogoutRequestLst).then(data => {
                if (data.HasError) {
                    this.GetMultilingualToast(data.Errors[0].ErrorMessage, 'error');
                }
                if (data && data.Result) {
                    this.GetMultilingualToast('TS.TS_SHIFT_END_SUCCESS', 'success');
                    this.ModalRef.close();
                }
            })
        }
    }

    SetRequestObj(LoginAction) {
        let RequestObj: LoginLogoutRequest = new LoginLogoutRequest();
        RequestObj.Properties = [];
        RequestObj.logoutOptionComplain = [];
        RequestObj.StaffId = this.StaffId;
        RequestObj.IsLogin = LoginAction;
        return RequestObj;
    }
}
